// extracted by mini-css-extract-plugin
export var outerContainer = "Modal-module--outer-container--tyTKa";
export var outerContainerVisible = "Modal-module--outer-container-visible--e8MuI";
export var innerContainer = "Modal-module--inner-container--8jqv8";
export var innerContainerVisible = "Modal-module--inner-container-visible--2VABz";
export var contentContainer = "Modal-module--content-container--bPaB4";
export var closeButton = "Modal-module--close-button--CaI-i";
export var closeButtonMobile = "Modal-module--close-button-mobile--GoKc5";
export var scrollbarTrack = "Modal-module--scrollbar-track---cVol";
export var scrollbarThumb = "Modal-module--scrollbar-thumb--+CN4C";